import { render, staticRenderFns } from "./EditClientComponent.vue?vue&type=template&id=4c3bb441"
import script from "./EditClientComponent.vue?vue&type=script&lang=js"
export * from "./EditClientComponent.vue?vue&type=script&lang=js"
import style0 from "./EditClientComponent.vue?vue&type=style&index=0&id=4c3bb441&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports